import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { get } from 'lodash'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { Modal } from 'components/layout/Modal'
import * as Yup from 'yup'
import {showSuccess, showError} from 'actions/Error'
import { handleSubmitResult } from 'actions/form'
import AdminCommonFormLayout from '../layout/AdminCommonFormLayout'
import AdminCommonForm from '../layout/AdminCommonForm'
import { FormikDropdownField } from 'components/form/Dropdown'
import { Grid } from '@material-ui/core'
import { adminCompanyReport } from './actions/admin_company_report'
import { adminCompanyReportNames, adminCompanyReportFrequencies } from 'admin/actions/admin_dropdown_options'
import { AdminCompanyReportGenerations } from './AdminCompanyReportGenerations'
import { FormikSwitchField } from 'components/form/SwitchField'

export const validationSchema = Yup.object().shape({
    report_name: Yup.string().required("Required"),
    frequency: Yup.string().required("Required")
})

export const AdminCompanyReport = ({inModal, setShowConfigureReportModal, setNewReport, company_id, company_report_id}) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const is_loading = company_report_id && adminCompanyReport.isLoading()
    const is_busy = adminCompanyReport.getIsSavingObject()

    const companyReport = useSelector(() => adminCompanyReport.getObject(company_report_id))
    const initialValues = Object.assign({}, companyReport)
    const companyReportNameOptions = adminCompanyReportNames.getAsOptions()
    const companyReportFrequencyOptions = adminCompanyReportFrequencies.getAsOptions()

    useEffect(() => {
        dispatch(adminCompanyReportNames.fetchListIfNeeded())
        dispatch(adminCompanyReportFrequencies.fetchListIfNeeded())
    }, [])

    useEffect(() => {
        if ( company_report_id ) {
            dispatch(adminCompanyReport.ensureObjectLoaded(company_report_id))
        }
    }, [company_report_id])

    const onSave = (values, formik_funcs) => {
        const on_ok = function(json) {
            dispatch(adminCompanyReport.invalidateList())
            showSuccess("Saved", "Report saved")
            {inModal ? setShowConfigureReportModal(false) : history.push(`/admin/${company_id}/company_reports`) }
            setNewReport(values.report_name + "_" + values.frequency)
        }
        values.company = company_id
        if ( company_report_id ) {
            values.id = company_report_id
            return dispatch(adminCompanyReport.saveObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        } else {
            return dispatch(adminCompanyReport.saveNewObject(values)).then((res) => handleSubmitResult({res, formik_funcs, on_ok}))
        }
    }

    const renderForm = (formik_props) => {
        const enabledText = formik_props.values.enabled ? 'enabled': 'disabled'
        const enabledTextColor = formik_props.values.enabled ? 'green' : 'red'
        return (
            <>
              <div style={{marginLeft: 20}}>
                <FormControlLabel
                  control={
                      <FormikSwitchField name="enabled"
                                           formik_props={formik_props}
                                           color="primary"
                      />
                  }
                  label={`Report sending ${enabledText}`}
                  style={{ color: enabledTextColor }}
                />

              </div>

              <FormikDropdownField name="report_name"
                                   label="Report Type"
                                   options={companyReportNameOptions}
                                   formik_props={formik_props}
                                   helperText={"What type of report do you want to generate?"}
              />


              <FormikDropdownField name="frequency"
                                   label="Frequency"
                                   options={companyReportFrequencyOptions}
                                   formik_props={formik_props}
                                   helperText={"How often do you want to generate this report?"}
              />
          </>
        )
    }

    const renderHistory = () => {
        return <AdminCompanyReportGenerations company_report_id={company_report_id} />
    }

    return (
        <>
        { !inModal ?
            <AdminCommonFormLayout breadcrumbs={[{name: 'admin_home'},
                                                 {name: 'company_reports', label: 'Reports', url: `/admin/${company_id}/company_reports/`},
                                                 {name: 'admin_company_report', label: `${get(adminCompanyReportNames.getObjectsById(), [get(companyReport, "report_name", "New"), "name"], "New")}`, url: `/admin/${company_id}/company_reports/${company_report_id || ""}`},
                                                ]}
                                   is_loading={is_loading}
                                   is_busy={is_busy}
                                   title={`Report : ${get(adminCompanyReportNames.getObjectsById(), [get(companyReport, "report_name", "New"), "name"], "New")}`}
                                   initial_values={initialValues}
                                   validationSchema={validationSchema}
                                   onSave={onSave}>
              {
                  ({formik_props}) =>
                      <Grid container spacing={2}>
                        <Grid item xs={12} lg={3}>{renderForm(formik_props)}</Grid>
                        <Grid item xs={12} lg={9}>{renderHistory()}</Grid>
                      </Grid>
              }
            </AdminCommonFormLayout>

            :

            <Modal
              title={`Report : ${get(adminCompanyReportNames.getObjectsById(), [get(companyReport, "report_name", "New"), "name"], "New")}`}
              onClose={() => setShowConfigureReportModal(false)}
              >
              <AdminCommonForm
                is_loading={is_loading}
                is_busy={is_busy}
                initial_values={initialValues}
                validationSchema={validationSchema}
                inModal={true}
                onSave={onSave}>
                {
                ({formik_props}) =>
                 <Grid container spacing={2}>
                   <Grid item xs={12}>{renderForm(formik_props)}</Grid>
                 </Grid>
                }
              </AdminCommonForm>
            </Modal>

          }
        </>
    )

}
